<script lang="ts">
    import { Button } from "sveltestrap";
    import { Link, navigate } from "svelte-navigator";
    import { vehiclesService } from '../services';
import ParamName from "./ParamName.svelte";
import { Third } from "../Model/Third";

    export let thirId: string;

    let vehicles: any[];

    $: loadVehicles(thirId);

    async function loadVehicles(thirId: string): Promise<void> {
        if (!thirId) {
            navigate('/');
            return;
        }

        vehicles = await vehiclesService.findbyThird(thirId);
        
    }

    async function newVehicle(){
        navigate('/vehiculo/new?third=' + thirId);
    }

</script>

<style>

</style>

{#if vehicles}
    <div class="row">
        <div class="col-12 mt-3 mb-3">
            <div class="text-end">
                <Button color="primary" on:click={() => newVehicle()}>
                   Nuevo vehículo
                </Button>
            </div>
        </div>
        <div class="col-12">
            {#if vehicles?.length}
            <table class="table">
                <thead>
                        <tr>
                            <th scope="col"></th>
                            <th scope="col">Matrícula</th>
                            <th scope="col">Bastidor</th>
                            <th scope="col">Tipo</th>
                            <th scope='col'>Marca/Modelos</th>
                        </tr>
                </thead>
                <tbody>
                    {#each vehicles as vehicle, index }
                        <tr>
                            <th scope="row">{index + 1}</th>
                            <td>
                                <Link to="/vehiculo/{vehicle.id}">
                                    {vehicle.plate}
                                </Link>
                            </td>
                            <td>{vehicle.frame}</td>
                            <td>
                                <ParamName id={vehicle.vehicleType} />
                            </td>
                            <td>
                                <ParamName id={vehicle.markId} />  <ParamName id={vehicle.modelId} />
                            </td>
                        </tr>
                    {/each}
                </tbody>
            </table>
            {:else}
                <div class="text-center pt-5">
                    <hr>
                    <h3>No hay vehículos para mostrar</h3>
                </div>
            {/if}
        </div>
    </div>
{/if}



